[
    {
        "name": "Wallet Gateway (localhost, dev)",
        "rpcUrl": "http://localhost:3030/api/v0/dapp"
    }
]
